import script from "./ConsumerMypageOrderDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageOrderDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerMypageOrderDetailView.vue?vue&type=style&index=0&id=48c2c4ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c2c4ca"]])

export default __exports__